import { ApiResponse } from "admin/src/ui/types/common/api-response";
import { ApiQueryConfig } from "api/types";

const GetOpenSubmissions: ApiQueryConfig<
  ApiResponse<any[]>,
  { societyId: string; type: string },
  Record<string, unknown>
> = {
  apiPath:
    "/api/v1/society/{societyId}/workflow/complex/submissions?type={type}",
  queryKey: {
    baseQueryKey: ["GetOpenSubmissions"],
    dynamicQueryKey: ["societyId", "type"],
  },
};

export { GetOpenSubmissions };
